<template>
  <div class="container">
    <h3 class="mb-2 text-center">Pagos seguros con Stripe</h3>
    <div class="stripe-info-box p-3 bg-white rounded shadow-sm">
      <p>
        En <strong>Evolve Grappling Pro</strong>, tu seguridad es nuestra prioridad. Por
        eso, todas las transacciones en línea son procesadas a través de
        <strong>Stripe</strong>, una de las plataformas de pago más confiables del mundo.
      </p>

      <ul>
        <li>
          Stripe utiliza <strong>cifrado SSL/TLS</strong> para proteger todos los datos
          que ingresas.
        </li>
        <li>
          Tus datos de tarjeta
          <strong>nunca son almacenados en nuestros servidores</strong>. Todo se procesa
          directamente en Stripe.
        </li>
        <li>
          Stripe cuenta con certificación <strong>PCI DSS de Nivel 1</strong>, el estándar
          más alto en seguridad de pagos.
        </li>
        <li>
          Toda la información es transmitida de forma segura y con protocolos modernos
          como <strong>HTTPS y AES-256</strong>.
        </li>
        <li>
          Detectores automáticos de fraude y autenticación segura (como
          <strong>3D Secure</strong>) se aplican cuando es necesario.
        </li>
        <li>
          Más de un millón de empresas confían en Stripe, incluyendo Amazon, Google,
          Shopify y Zoom.
        </li>
      </ul>

      <p class="mt-4">
        Si tienes preguntas sobre la seguridad de tus pagos, contáctanos a:
        <a href="mailto:evolvegrapplingpro@coudera.com"
          >evolvegrapplingpro@coudera.com</a
        >.
      </p>
    </div>
  </div>
</template>

<style scoped>
.stripe-info-box {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  padding: 1.5rem;
}

@media (max-width: 576px) {
  .container {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .stripe-info-box {
    padding: 1rem;
  }

  .stripe-info-box p,
  .stripe-info-box li {
    font-size: 0.85rem;
  }
}
</style>
